<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import FirstStepsExplanation from '#/detailsReport/FirstStepsExplanation'
import ContentBlocker from '#/general/ContentBlocker'
import { inject } from 'vue'
import CheckListV1 from '#/detailsReport/version1/CheckListV1'
import CheckListV2 from '#/detailsReport/version2/CheckListV2'
const { lead, potential, version } = useDetailsReport()
const { pages, global, application } = inject('Shared')
</script>

<template lang="pug">
.first-steps--container(:class="version === 2 ? 'version2Margin' : ''")
  .first-steps--title(v-if="pages.detailReport.firstSteps.title.text && version === 1") {{ pages.detailReport.firstSteps.title.text }}
  .relative-position.full-width
    content-blocker(v-if="lead && [null, undefined].includes(lead.reasonOfInterest)")
    first-steps-explanation(v-if="pages.detailReport.showProjectPhases && version === 1")
    check-list-v1(v-if="pages.detailReport.showCheckListPanel && version === 1")
    check-list-v2(v-else-if="pages.detailReport.showCheckListPanel && version === 2")
    slot(name="contactSales")
</template>

<style scoped lang="sass">
.version2Margin
  @media screen and (min-width: 1024px)
    margin-top: 50px !important
  @media screen and (max-width: 1023px)
    margin-top: 20px !important
.first-steps--container
  width: 100%
  margin: 40px 0 40px 0
  @media screen and (max-width: 599px)
    margin: 40px 0 0 0
  .first-steps--title
    color: v-bind('pages.detailReport.firstSteps.title.color')
    margin-bottom: 30px
    @media screen and (min-width: 1024px)
      font-weight: v-bind('pages.detailReport.firstSteps.title.fontWeight')
      font-size: v-bind('pages.detailReport.firstSteps.title.fontSize')
    @media screen and (max-width: 1023px)
      font-weight: v-bind('pages.detailReport.firstSteps.title.fontWeightMobile')
      font-size: v-bind('pages.detailReport.firstSteps.title.fontSizeMobile')
  .detail-analysis--container
    @media screen and (min-width: 1024px)
      display: flex
      flex-direction: row
      justify-content: space-between
    @media screen and (max-width: 1023px)
    .title
      font-weight: 500
      color: #007BFF
      display: flex
      justify-content: center
      align-items: center
      @media screen and (min-width: 1024px)
        font-size: 18px
        line-height: 22px
        text-align: justify
      @media screen and (max-width: 1023px)
        font-size: 14px
        line-height: 160%
        margin: 15px 0
    .titleV2
      font-weight: 700
      color: #1F47CD
      display: flex
      justify-content: center
      align-items: center
      @media screen and (min-width: 1024px)
        font-size: 18px
        line-height: 22px
        text-align: justify
      @media screen and (max-width: 1023px)
        font-size: 14px
        line-height: 160%
        margin: 15px 0
    .analysis-btn
      height: 54px
      @media screen and (min-width: 1024px)
        min-width: 498px
        margin-left: 30px
      @media screen and (max-width: 1023px)
        width: 100%
</style>
